<template>
  <div class="upper-strata-common-top">
    <div class="upper-strata-common-top-left">{{upperStrataName}}</div>
    <div class="upper-strata-common-top-center"></div>
    <div class="upper-strata-common-top-right">
      <div class="upper-strata-common-top-right-nav-item" v-for="nav in navList" @click="changeRoute(nav.route)">
        <i :class="nav.icon" v-if="nav.name !== '安全中心'"></i>
        <span v-if="nav.name !== '安全中心'">{{nav.name}}</span>
        <el-dropdown @command="handleCommand" class="top-nav-box" v-if="nav.name === '安全中心'">
            <span class="el-dropdown-link">
              <i :class="nav.icon" style="color:#ffffff;margin: 0;"></i>
              <span style="color:#ffffff;">{{nav.name}}</span>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginOut"><i class="el-icon-switch-button"></i>安全退出</el-dropdown-item>
            <!--<el-dropdown-item command="repair-over-view"><i class="el-icon-damai-xiugai"></i>智慧报修</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
  </div>
</template>

<script>
  import {errorHandler} from '../../utils/errorHandler'
  import {api} from '../api/Summary'

  export default {
    name: 'upper-strata-common-top',
    data () {
      return {
        upperStrataName: '',
        navList: [
          {name: '首页', icon: 'el-icon-damai-shouye', route: 'summary-page'},
          {name: '信息发布', icon: 'el-icon-damai-basic', route: 'upper-information-group-profile-info'},
          {name: '账号管理', icon: 'el-icon-damai-icon-test', route: 'upper-account-superior-account-management'},
          {name: '安全中心', icon: 'el-icon-damai-yanzhengma', route: ''},
        ],
      }
    },
    created () {
      this.getGroupInfo()
    },
    methods: {
      changeRoute (routeName) {
        if (routeName) {
          this.$router.push({
            name: routeName
          })
        }
      },
      getGroupInfo () {
        this.$axios.post(api.getGroupInfo, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                this.upperStrataName = data.groupName || `数智园区上层平台`
              } else {
                this.upperStrataName = `数智园区上层平台`
              }
            }
          })
          .catch(errorHandler('查询信息失败'))
      },
      // 下拉按钮点击事件
      handleCommand (command) {
        if(command === 'loginOut') {
          this.loginOut()
        } else if(command === 'modifyPassword') {
          this.dialogVisible = true
        }
      },

      // 退出
      loginOut () {
        this.$confirm('确定退出当前账号？', '提示')
          .then(() => {
            this.$axios.post(api.upperLogout, {})
              .then(res => {
                if (res.data.retCode === 1) {
                  sessionStorage.clear()
                  bus.global.upperData = {
                    accountName: '',
                    accountCode: '',
                    token: '',
                    yqAppCodeList: [],
                    groupAppCode: '',
                  }
                  this.$router.push({
                    name: 'upper-login'
                  })
                }
              })
              .catch(errorHandler('退出失败'))
          })
          .catch(() => {
            console.log('取消退出')
          })
      }
    }
  }
</script>

<style scoped lang="less">
  .upper-strata-common-top {
    height: 0.9rem;
    line-height: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    background: #091220;
    .upper-strata-common-top-left {
      font-size: 0.42rem;
      font-weight: 600;
      color: #ffffff;
    }
    .upper-strata-common-top-center {
      font-size: 0.42rem;
      font-weight: 600;
      color: #ffffff;
    }
    .upper-strata-common-top-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      line-height: 0.9rem;
      .upper-strata-common-top-right-nav-item {
        height: 0.6rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #ffffff;
        padding: 0 0.36rem;
        margin-right: 0.1rem;
        position: relative;
        z-index: 5;
        cursor: pointer;
        i {
          margin-right: 0.1rem;
        }
        span {
          font-size: 0.28rem;
        }
      }
      .upper-strata-common-top-right-nav-item::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        border-radius: 5px;
        z-index: -1;
        background: #15ADAE;
        transform: skewX(-25deg);
      }
      .upper-strata-common-top-right-nav-item:hover::after {
        background: #54F3F4;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/UpperStrataCommonTop.vue